module.exports = __webpack_public_path__ + "static/media/normal-circular.dc428195.png";